import { render, staticRenderFns } from "./ArticleDetails.vue?vue&type=template&id=48a99e2d&scoped=true&"
import script from "./ArticleDetails.vue?vue&type=script&lang=js&"
export * from "./ArticleDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetails.vue?vue&type=style&index=0&id=48a99e2d&lang=scss&scoped=true&"
import style1 from "./ArticleDetails.vue?vue&type=style&index=1&id=48a99e2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a99e2d",
  null
  
)

export default component.exports